export enum TableVariant {
    PRIMARY = "primary",
    SECONDARY = "secondary",
}
